import { useCallback, useState } from "react";
import { ColumnFilter, SortModel } from "@romeis/romeis-data-grid";
import { DataRequestState, Filter } from "./types";

export function useRomeisGridHandlers<TFilter extends Filter>(
  request: DataRequestState<TFilter>,
  initialPageSize: number = 100000
) {
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: initialPageSize,
  });
  const [filterModel, setFilterModel] = useState<ColumnFilter[]>([]);
  const [sortModel, setSortModel] = useState<SortModel | null>(null);

  const onPageChange = useCallback((page: number) => {
    setPagination((prev) => ({ ...prev, page }));
  }, []);

  const onPageSizeChange = useCallback(
    (pageSize: number) => {
      setPagination((prev) => ({ ...prev, pageSize }));
      request.setLimit(pageSize);
    },
    [request]
  );

  const onFilterModelChange = useCallback((model: ColumnFilter[]) => {
    setFilterModel(model);
  }, []);

  const onSortModelChange = useCallback((model: SortModel | null) => {
    setSortModel(model);
  }, []);

  return {
    pagination,
    setPagination,
    filterModel,
    setFilterModel,
    sortModel,
    setSortModel,
    onPageChange,
    onPageSizeChange,
    onFilterModelChange,
    onSortModelChange,
  };
}
